export default "__VITE_ASSET__CA6zKnXw__"